import { render, staticRenderFns } from "./WorkspaceMenu.vue?vue&type=template&id=4e0c6d72&scoped=true"
import script from "./WorkspaceMenu.vue?vue&type=script&lang=ts"
export * from "./WorkspaceMenu.vue?vue&type=script&lang=ts"
import style0 from "./WorkspaceMenu.vue?vue&type=style&index=0&id=4e0c6d72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0c6d72",
  null
  
)

export default component.exports